// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle_LbABp {
  flex-grow: 1;
}

.toggleContainer_X0Obq {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/aisleHeatmapping/detail/AisleHeatmapImageRenderer.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb","sourcesContent":[".toggle {\n  flex-grow: 1;\n}\n\n.toggleContainer {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggle": `toggle_LbABp`,
	"toggleContainer": `toggleContainer_X0Obq`
};
export default ___CSS_LOADER_EXPORT___;
